import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

  static values = { name: String }

  connect() {
    this.element.addEventListener('animationend', () => this.#handleAnimationEnd(event))
  }

  disconnect() {
    this.element.removeEventListener('animationend', () => this.#handleAnimationEnd(event))
  }

  #handleAnimationEnd (event) {
    if (!this.hasNameValue || event.animationName === this.nameValue) {
      this.element.remove()
    }
  }
}